<template>
    <div>
        <div id="prime-advantages">
            <picture v-if="$scope.HAS_PRIME_PROMO">
                <source media="(max-width: 790px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2019/prime/pop-up-mobile-33.png?auto=format&lossless=1`">
                <source media="(max-width: 1000px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2019/prime/pop-up-tablet-33.png?auto=format&lossless=1`">
                <img :src="`${$scope.CDN_IMAGES}/images/site/2019/prime/pop-up-site-33.png?auto=format&lossless=1`"
                     alt="Assine Chico Rei Prime e garanta frete grátis por 1 ano"
                     class="img-responsive">
            </picture>
            <picture v-else>
                <source media="(max-width: 790px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2019/prime/pop-up-mobile.jpg?auto=format&lossless=1`">
                <source media="(max-width: 1000px)"
                        :srcset="`${$scope.CDN_IMAGES}/images/site/2019/prime/pop-up-tablet.jpg?auto=format&lossless=1`">
                <img :src="`${$scope.CDN_IMAGES}/images/site/2019/prime/pop-up-site.jpg?auto=format&lossless=1`"
                     alt="Assine Chico Rei Prime e garanta frete grátis por 1 ano"
                     class="img-responsive">
            </picture>

            <div class="card-block form-inline mt">
                <a class="text-underline" @click="$emit('dismiss')" aria-label="Close"
                   style="flex: 1">
                    Não quero assinar agora
                </a>

                <button class="btn" @click.prevent="$emit('subscribe')">
                    Quero ser Prime
                </button>
            </div>
        </div>

        <div class="description-prime card-block">
            * Ao clicar em "Quero Ser Prime" você aceita os <a class="text-underline text-accent"
                                                               @click.prevent="showPrimeTerms = !showPrimeTerms">Termos
            e Condições</a>.
        </div>
        <div class="card-block" v-show="showPrimeTerms">
            <h3>Termos e Condições do Chico Rei Prime</h3>
            <h4>Compra</h4>
            <p>Ao adicionar a assinatura no carrinho e aceitar os termos e condições, a opção de frete
                grátis (Prime) será disponibilizada automaticamente. Ainda assim é possível escolher uma
                outra opção de entrega, mediante pagamento do valor correspondente. Por ser uma nova
                modalidade de envio, a adesão ao Prime só pode ser feita em conjunto com a compra de
                outro produto.</p>
            <h4>Entrega Grátis</h4>
            <p>O prazo de entrega, que pode ser consultado no carrinho e na etapa final da compra, varia
                de acordo com os produtos escolhidos. Ao aderir ao plano, as condições gerais e valores
                mínimos de frete grátis por região serão substituídas pelo regulamento de frete do Chico
                Rei Prime. A escolha da forma de envio utilizada na modalidade Prime fica a critério da
                Chico Rei. O cliente Prime, ao escolher uma modalidade de entrega diferente da Prime,
                deverá arcar com os valores de envio exibidos no momento da compra.</p>
            <h4>Cancelamento</h4>
            <p>O cancelamento do Prime pode ser feito em até 30 dias após à adesão, desde que nenhum dos
                benefícios tenham sido utilizados em outra compra. Ao solicitar o cancelamento, o seu
                pedido também será cancelado e por isso deve ser feito novamente no site, caso ainda
                tenha interesse nos demais produtos, para que os valores referentes ao envio sejam
                computados corretamente. Não é permitido cancelar a assinatura após o envio do pedido em
                que foi feito o pagamento da mesma. Nesse caso, é necessário realizar a devolução dos
                produtos, arcando com os custos de envio, que o cancelamento será feito por nossa equipe
                após o processo de aprovação da devolução. Para solicitar o cancelamento, basta enviar
                um email para <a href="mailto:contato@chicorei.com.br" target="_blank" rel="noopener">contato@chicorei.com.br</a>.
            </p>
            <h4>Troca</h4>
            <p>Por não ser um produto físico, não é permitido realizar a troca do Prime por outro
                produto, somente o cancelamento integral do pedido para receber a devolução do valor da
                assinatura. Para solicitar o cancelamento, basta enviar um email para <a
                        href="mailto:contato@chicorei.com.br" target="_blank"
                        rel="noopener">contato@chicorei.com.br</a>.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PrimeModal",

        data() {
            return {showPrimeTerms: false}
        }
    }
</script>